/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { newGatewayUrl } from '@/constant';
import request from '@hb/sharp-request';
import { Toast } from '@hb/coffee';
import { ToolBoxVo } from './types';

// 提交计算数据 { loadingMessage: '提交中', successToast: '已提交' }
export const submintPayment = <T = string>(toolForm: ToolBoxVo): Promise<T> => request
  .postGate<T>('f.common.repayment.calc', toolForm, {
    loadingMessage: '提交中',
    baseURL: newGatewayUrl,
  })
  .then((data) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    Toast.success('已提交');

    return data;
  });

const ToolBoxApi = {
  submintPayment,
};

export default ToolBoxApi;
